document.addEventListener("DOMContentLoaded", () => {
  const jsonWithIdProduct = JSON.parse(document.getElementById("dependent_product").innerHTML) || false;
  if (!jsonWithIdProduct) return;
  let { main: mainProducts, dependent: dependentProduct, dependent_variant } = jsonWithIdProduct;
  mainProducts = mainProducts.map(product =>  +product)
  document.addEventListener("cart:change", handleCartChange);

  async function handleCartChange(event) {
    const items = await getItemsCart(event);
    removeDependedProduct(items);
  }

  async function fetchCartItems() {
    const res = await fetch("/cart.js");
    const cartItems = await res.json();
    return cartItems.items;
  }

  async function getItemsCart(event) {
    const items = event?.detail ? event.detail.cart.items : await fetchCartItems();
    return items;
  }

  async function removeAfterLoadPage(event) {
    const items = await getItemsCart(event);
    removeDependedProduct(items);
  }

  function removeDependedProduct(items) {
    const isCartMainProduct = items.some((item) => mainProducts.includes(Number(item.product_id)));
    const isCartDependentProduct = items.some((item) => Number(item.product_id) === Number(dependentProduct));

    if (!isCartMainProduct && isCartDependentProduct) {
      fetch(`${Shopify.routes.root}cart/change.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: String(dependent_variant),
          quantity: 0,
        }),
      })
        .then((response) => response.json())
        .then((response) => {
          console.log(response)

        })
        .catch((error) => console.log(error));
    }
  }
  removeAfterLoadPage();
});
